import { FunctionComponent, useEffect } from 'react';

interface IPageHelmetProps {
  title?: string;
}
export const PageHelmet: FunctionComponent<IPageHelmetProps> = (props: IPageHelmetProps) => {

  const {
    title
  } = props;

  useEffect(() => {
    document.title = title || 'Dance World';
  }, [title]);

  return null;
}